import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SharedService } from 'src/app/main/consultor/services/shared.service';
import { PageEvent } from '@angular/material/paginator';
import { ErrorModel } from 'src/app/core/models/error.model';
import { SharedModel } from 'src/app/main/consultor/models/shared.model';


@Component({
  selector: 'app-shared',
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.scss']
})
export class SharedComponent implements OnInit {
  displayedColumns: string[] = [
    'codigo', 'criadoEm', 'atualizadoEm', 'consultor',
    'empresa', 'conexao', 'descricaoVaga', 'ponto', 'observacao'
  ];
  loading = false;
  dataSource = new MatTableDataSource<SharedModel>();
  pageSize = 10;
  length = 10;
  pageRanger = [10, 20, 50];
  pageFirst = 0;

  constructor(
      private dialogService: DialogService,
      private router: Router,
      private sanitizer: DomSanitizer,
      private sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.getAllPageble(this.pageFirst, this.pageSize);
  }

  changePage(e: PageEvent): void {
    this.getAllPageble(e.pageIndex, e.pageSize);
  }

  sanitize(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getAllPageble(page: number, size: number): void {
    this.sharedService.getHaoFromShared(page, size).subscribe(results => {
      this.loading = true;
      this.dataSource.data = results.content;
      this.length = results.totalElements;
    }, (error: ErrorModel) => {
      this.dialogService.showNotification(error.message);
    }).add(() => {
      this.loading = false;
    });
  }

}
